/**
 * Licensed Materials - Property of ROOTCLOUD
 * THIS MODULE IS "RESTRICTED MATERIALS OF ROOTCLOUD"
 * (c) Copyright ROOTCLOUD Inc. 2021 All Rights Reserved
 *
 * The source code for this program is not published or
 * otherwise divested of its trade secrets
 */
/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-09-14 11:19:35
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-09-28 16:22:08
 */
import request from "@/utils/request";
const systemUrl = window.env.scimSystem;
// 获取数据字典
export function getDictionary(params, headers) {
  return request({
    url: `${systemUrl}/api/v1/dict/cascade-dict/code/${params.code}`,
    method: "get",
    headers
  });
}

// 搜索：查询默认项
export function getDefaultSearchItems(params) {
  return request({
    url: `${systemUrl}/api/v1/form/original/form-code/${params.formCode}`,
    method: "get"
  });
}
// 搜索：查询用户配置项、已保存的搜索结果
export function getSettingSearchItems(params) {
  return request({
    url: `${systemUrl}/api/v1/form/user/form-code/${params.formCode}`,
    method: "get"
  });
}
// 搜索：保存用户配置项
export function saveSettingSearchItems({ formCode, data }) {
  return request({
    url: `${systemUrl}/api/v1/form/user/form-code/${formCode}/query-param`,
    method: "patch",
    data
  });
}
// 搜索：保存当前搜索结果
export function saveSearchHistory({ formCode, data }) {
  return request({
    url: `${systemUrl}/api/v1/form/user/form-code/${formCode}/query-history`,
    method: "patch",
    data
  });
}
// 搜索：添加当前搜索结果
export function addSearchHistory({ formCode, data }) {
  return request({
    url: `${systemUrl}/api/v1/form/user/form-code/${formCode}/query-history`,
    method: "post",
    data
  });
}
// 搜索：删除某搜索结果
export function deleteSearchHistory({ formCode, id }) {
  return request({
    url: `${systemUrl}/api/v1/form/user/form-code/${formCode}/query-history/${id}`,
    method: "delete"
  });
}

// 搜索：获取已保存的搜索条件
export function getSearchHistory({ formCode, data }) {
  return request({
    url: `${systemUrl}/api/v1/form/user/form-code/{form-code}`,
    method: "patch",
    data
  });
}
// 系统参数
export function getParameterConfig(key) {
  return request({
    url: `${systemUrl}/api/v1/parameter-config/config-key/${key}`,
    method: "get",
    params: {}
  });
}

export function getSchema(code) {
  return request({
    url: `${systemUrl}/api/v1/resource-structure/${code}`,
    method: `get`
  });
}

